import { Box, Modal, Stack, Typography } from "@mui/material";

import { BookOnboardingButton } from "components/Shipper/components/BookOnboardingButton";
import { MODAL_STYLE } from "layouts/constants";

interface Props {
  open: boolean;
  onClose: VoidFunction;
}

export function MissingPostingPermissionModal(props: Props) {
  const { open, onClose } = props;
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={MODAL_STYLE}>
        <Stack spacing={2}>
          <Typography variant="h6" component="h2">
            Let&apos;s get you set up to post
          </Typography>
          <Typography variant="body1">
            Before posting your first shipment, our team will walk you through
            getting your account ready. Schedule a quick onboarding session and
            we&apos;ll unlock posting for your company.
          </Typography>
          <Box>
            <BookOnboardingButton
              buttonSize="large"
              trackingSource="posting_permission_modal"
            />
          </Box>
        </Stack>
      </Box>
    </Modal>
  );
}
